import { MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { getTranslateByKey, isShowControlByElementId } from '@/main/services/utils';
import { Controls } from '@/main/services/constants/constantsControl';

import { useThreeDotsClaimContext } from '../contex';
import WrapperModalBulkReturnClaim from '@/main/components/shared/modalBulkReturnClaim/modalBulkReturnClaim';

export interface IThreeDotsClaimReturnProps {
  guidClaim: string;
  showReturnButton: boolean;
  refreshClaim: () => void;
}

function ThreeDotsClaimReturn(props: IThreeDotsClaimReturnProps) {
  const {
    closeThreeDotsClaim,
    generateIdMenu,
  } = useThreeDotsClaimContext();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  function handleClick() {
    setIsOpenModal(true)
    closeThreeDotsClaim();
  }
  function closeModal() {
    setIsOpenModal(false);
  }

  if (!props.showReturnButton) return null;
  if (!isShowControlByElementId(Controls.IdBtnReturnOrderInClaim)) return null;

  return (
    <>
      <MenuItem
        id={generateIdMenu('return')}
        onClick={handleClick}
      >
        {getTranslateByKey('information.return')}
      </MenuItem>

      <WrapperModalBulkReturnClaim
        isOpenModal={isOpenModal}
        closeModal={closeModal}
        setIsOpenModal={setIsOpenModal}
        {...props}
      />
    </>
  )
}

export { ThreeDotsClaimReturn };
